import * as d3 from 'd3'
export default {
  methods: {

    form_Diagram(selection) {

      let forms = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      forms
      .append('text')
      .attr('x', 20).attr('y', 28).attr('fill', '#000') .attr('font-size', 17).attr('font-style', 'italic')
      .text('Database Diagram Input Forms')

      forms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 60).attr('width', 167)

      let input = [
        {id: 'DIAGRAM_NAME', label: 'Diageam Name',        width: 250, x: 30, y: 140, maxLen: 30},
        {id: 'DIAGRAM_DESC', label: 'Diagram Description', width: 450, x: 30, y: 190, maxLen: 60},
      ]

      input.forEach(d=> {
        this.dia_InputBox(forms, d)
      })
      this.gmx_Line(forms, 30, 820, 250, 250, '#E0E0DF', .5, 1)


      let ececution = selection
      .append('g')
      .attr('transform', `translate(20, 280)`)

      // CALENDER -------------------------------------------------------------
      let calender = ececution
      .append('g')
      .attr('transform', `translate(25, 0)`)

      calender
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Calender.svg`).attr('width', 60)

      this.dia_Dropdown(calender, this.database, {id: 'CUTOFF_DB', label: 'Database', boxWidth: 150, x: 10, y: 90, verify: 'N'})

      input = [
        {id: 'CUTOFF_SCHEMA', label: 'Schema Name',   width: 150, x: 10, y: 140, maxLen: 18},
        {id: 'CUTOFF_TBL',    label: 'Table Name',    width: 150, x: 10, y: 190, maxLen: 18},
        {id: 'CUTOFF_CODE',   label: 'Cutoff (Code)', width: 150, x: 10, y: 240, maxLen: 18},
        {id: 'CUTOFF_DATE',   label: 'Cutoff Date',   width: 150, x: 10, y: 290, maxLen: 10},
      ]
      input.forEach(d=> { this.dia_InputBox(calender, d) })


      // VERIFY -------------------------------------------------------------
      let verify = ececution
      .append('g')
      .attr('transform', `translate(225, 0)`)

      verify
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Verify.svg`).attr('width', 60)

      input = [
        {id: 'VERIFY_MODAL', label: 'Verify Model Name', width: 150, x: 10, y: 90, maxLen: 18},
      ]
      input.forEach(d=> { this.dia_InputBox(verify, d) })



      // DEV SERVER -------------------------------------------------------------
      let dev = ececution
      .append('g')
      .attr('transform', `translate(425, 0)`)

      dev
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Dev.svg`).attr('width', 60)

      this.dia_Dropdown(dev, this.database, {id: 'DEV_DB', label: 'Database', boxWidth: 150, x: 10, y: 90, verify: 'N'})
      
      input = [
        {id: 'DEV_SCHEMA',    label: 'Schema Name',    width: 150, x: 10, y: 140, maxLen: 18},
        {id: 'DEV_PROCEDURE', label: 'Procedure Name', width: 150, x: 10, y: 190, maxLen: 18},
      ]
      input.forEach(d=> { this.dia_InputBox(dev, d) })



      // SERVICE SERVER -------------------------------------------------------------
      let diagram = ececution
      .append('g')
      .attr('transform', `translate(625, 0)`)

      diagram
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Service.svg`).attr('width', 60)

      this.dia_Dropdown(diagram, this.database, {id: 'SVS_DB', label: 'Database', boxWidth: 150, x: 10, y: 90, verify: 'N'})

      input = [
        {id: 'SVS_SCHEMA',    label: 'Schema Name',    width: 150, x: 10, y: 140, maxLen: 18},
        {id: 'SVS_PROCEDURE', label: 'Procedure Name', width: 150, x: 10, y: 190, maxLen: 18},
      ]
      input.forEach(d=> { this.dia_InputBox(diagram, d) })



      // DROPDOWNs Move to Front
      d3.select(`#DROPDOWN_DEV_DB`).moveToFront()
      d3.select(`#DROPDOWN_SVS_DB`).moveToFront()
      d3.select(`#DROPDOWN_CUTOFF_DB`).moveToFront()

      let buttons = selection
      .append('g')
      .attr('transform', `translate(630, 670)`)

      buttons
      .append('image') // Save
      .attr('xlink:href', this.HOST + `/Database/btn/Save.svg`).attr('x', 0).attr('y', 0).attr('width', 80)
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.save_Diagram()
      })

      buttons
      .append('image') // Close
      .attr('xlink:href', this.HOST + `/Database/btn/Close.svg`).attr('x', 100).attr('y', 0).attr('width', 80)
      .call(this.call_Closed)
    },



    verify_Diagram(selection, props, stg) {
    }

  }
}